export const pillars = ['CAD Notes', 'Pass-Downs', 'QA & Protocols', 'Training', 'SOPs & Admin', 'Resilience & Career'];
// Prompt titles below are the real titles from the volumes (lines "## PROMPT" in V1.md … V6.md).
export const volumes = [{
  n: 1,
  emoji: '📘',
  short: 'CAD Notes & Incident Narratives',
  title: 'CAD Notes & Incident Narratives (Prompts 01–20)',
  desc: '20 prompts that turn rushed shorthand, radio log entries and CAD time stamps into clean, factual narratives.',
  prompts: ['Shorthand CAD Notes to Clean Narrative', 'Call-Taker Narrative', 'Dispatcher Narrative and Radio Summary', 'Chronological Incident Timeline from CAD Time Stamps', 'Text-to-911 Conversation Summary', 'Narrative Consistency Check Against CAD Times']
}, {
  n: 2,
  emoji: '📕',
  short: 'Shift Handovers, Logs & Supervisor Reports',
  title: 'Shift Handovers, Logs & Supervisor Reports (Prompts 21–40)',
  desc: '20 prompts for pass-downs, briefings, activity logs, outage reports and the reports your supervisor asks for.',
  prompts: ['End-of-Shift Pass-Down', 'Start-of-Shift Briefing', 'Console Position Handover Checklist', 'Supervisor Shift Report', 'Equipment, CAD or Phone Outage Report', 'Incident After-Action Summary']
}, {
  n: 3,
  emoji: '📓',
  short: 'QA, Call Review & Protocol Study',
  title: 'QA, Call Review & Protocol Study (Prompts 41–60)',
  desc: '20 prompts to review your own calls, reflect on QA scores and turn protocols and SOPs into study material.',
  prompts: ['Self-Review of a Call From My Notes', 'QA Scorecard Reflection', "Call Review Against My Agency's Checklist", 'EMD/EFD/EPD Protocol Flashcards', 'Radio Phraseology and Plain-Language Practice', 'Certification Exam Study Plan']
}, {
  n: 4,
  emoji: '📗',
  short: 'Training New Telecommunicators — CTO Toolkit',
  title: 'Training New Telecommunicators — CTO Toolkit (Prompts 61–80)',
  desc: '20 prompts for training plans, DORs, remediation, role-plays, quizzes and sign-off memos.',
  prompts: ['Training Plan for a New Hire by Phase', 'Daily Observation Report (DOR) Draft', 'Remediation Plan', 'Call-Taking Role-Play (Trainer Plays Caller)', 'Map and Geography Quiz for My Jurisdiction', 'End-of-Training Evaluation Narrative']
}, {
  n: 5,
  emoji: '📙',
  short: 'SOPs, Admin & Professional Communication',
  title: 'SOPs, Admin & Professional Communication (Prompts 81–100)',
  desc: '20 prompts for SOP drafts, quick reference cards, emails, recruitment posts, budget requests and reports.',
  prompts: ['SOP Draft From Bullet Points', 'Quick Reference Card From a Long SOP', 'Email to IT or Vendor About a CAD Issue', 'Dispatcher Recruitment Post and Job Ad', 'Budget and Equipment Request Justification', 'Annual Comm-Center Report Outline']
}, {
  n: 6,
  emoji: '📔',
  short: 'Stress, Resilience, Career & Promotion',
  title: 'Stress, Resilience, Career & Promotion (Prompts 101–120)',
  desc: '20 prompts for decompression, sleep on nights, overtime boundaries, resumes, interviews and promotion.',
  prompts: ['End-of-Shift Decompression Routine', 'After a Hard Call Reflection', 'Sleep Plan for Nights and Rotating Shifts', 'Boundaries and Overtime Planning', 'Interview Prep for Dispatcher or Supervisor', 'Promotion Packet and Letter of Interest']
}];
export const volumeIncludes = ['Complete copy-and-paste prompts (not descriptions)', 'Fill-in-the-blank [brackets] for your own de-identified facts', 'A "Use it when" line and a pro tip for every prompt', 'Built for after the call: never during a live call'];
export const bonuses = [{
  n: '01',
  was: '$32',
  title: 'THE 500+ CAD NOTE & NARRATIVE PHRASE BANK™',
  desc: 'Clear, factual phrases for CAD notes, narratives and supplements, so you stop searching for the right words at end of shift.',
  cover: 'Phrase Bank',
  image: 'https://cdn.magicpatterns.com/uploads/2NArbEdx4ihEcNM93C5z9e/Portada_digital_de_operaciones_CAD.webp'
}, {
  n: '02',
  was: '$29',
  title: 'THE CALL REVIEW SELF-AUDIT CHECKLIST™',
  desc: 'Review your own documentation before QA does: a simple checklist to catch gaps, missing times and unclear entries.',
  cover: 'Self-Audit',
  image: 'https://cdn.magicpatterns.com/uploads/ojhArZGbdqau6Q5jzGSPFF/Portada_digital_de_operaciones_CAD_(1).webp'
}, {
  n: '03',
  was: '$32',
  title: 'THE SHIFT PASS-DOWN & BRIEFING TEMPLATES™',
  desc: 'Ready-to-fill templates so the oncoming shift gets open incidents, unit status and safety notes in two minutes.',
  cover: 'Pass-Down',
  image: 'https://cdn.magicpatterns.com/uploads/8DiRKMSKiF8TmYnWLWuCUv/Portada_digital_de_operaciones_CAD_(2).webp'
}, {
  n: '04',
  was: '$27',
  title: 'THE 12-HOUR SHIFT SURVIVAL PLANNER FOR DISPATCHERS™',
  desc: 'Sleep, meal and decompression planners built around nights, rotations and mandatory overtime.',
  cover: '12-Hour Shift',
  image: 'https://cdn.magicpatterns.com/uploads/fwx4ypAZgEJHWwVejpiKmb/Portada_digital_de_operaciones_CAD_(3).webp'
}];
export const bundleImage = 'https://cdn.magicpatterns.com/uploads/rcfhmMQEXEqzrVBZsR4rwc/Kit_de_herramientas_IA_para_operadores_911.webp';
